/**
 * Created by jv on 18/01/2017.
 */
const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class Ticket
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.type = options.type;
    this.code = options.code;
    this.email = options.email;
    // this.orderId = options["order-id"];
    this.subscriptionKey = options["subscription-key"];
    this.enabled = options.enabled;
    this.revoked = options.revoked;
    this.created = options.created;
    this.expires = options.expires;
    this.used = options.used;
    this.data1 = options.data1;
  };

  set expires(date)
  {
    this._expires = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  };

  get expires()
  {
    return utils.isMomentObject(this._expires) ? this._expires.format("DD-MM-YYYY") : null;
  };
};



// WEBPACK FOOTER //
// ./app/js/models/ticket.js